import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import nl from "./locales/nl.json";

const STORAGE_KEY = "izzygo_lang";
const SUPPORTED = ["en", "fr", "nl"];

// Always English by default; only honor an explicit prior choice from localStorage.
// No language-detector, no Teams-locale read, no inference.
function initialLanguage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED.includes(stored)) {
      return stored;
    }
  } catch (e) {
    // localStorage unavailable (private mode / SSR) -> default English.
  }
  return "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    nl: { translation: nl },
  },
  lng: initialLanguage(),
  fallbackLng: "en",
  supportedLngs: SUPPORTED,
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
